import React from "react";
import {
  FormControl,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
} from "@mui/material";
import type { SelectChangeEvent } from "@mui/material/Select";

export type TestFilterSelectOption = {
  value: string;
  label: string;
};

type TestFilterSelectProps = {
  label: string;
  value: string;
  onChange: (value: string) => void;
  options: TestFilterSelectOption[];
  disabled?: boolean;
  placeholder?: string;
  minWidth?: number;
  fullWidth?: boolean;
  className?: string;
  labelId?: string;
};

const TestFilterSelect: React.FC<TestFilterSelectProps> = ({
  label,
  value,
  onChange,
  options,
  disabled = false,
  placeholder = "Select...",
  minWidth = 140,
  fullWidth = false,
  className,
  labelId,
}) => {
  const id =
    labelId || `test-filter-${label.toLowerCase().replace(/\s+/g, "-")}`;

  const handleChange = (event: SelectChangeEvent<string>) => {
    onChange(event.target.value);
  };

  return (
    <FormControl
      variant="outlined"
      size="small"
      className={className}
      fullWidth={fullWidth}
      sx={
        fullWidth
          ? { width: "100%", minWidth: 0 }
          : { minWidth }
      }
    >
      <InputLabel id={id} shrink>
        {label}
      </InputLabel>
      <Select
        labelId={id}
        value={value}
        onChange={handleChange}
        input={<OutlinedInput label={label} notched />}
        displayEmpty
        renderValue={(selected) => {
          if (!selected) return placeholder;
          const match = options.find((o) => o.value === selected);
          return match?.label ?? selected;
        }}
        disabled={disabled}
      >
        <MenuItem value="">
          <em>{placeholder}</em>
        </MenuItem>
        {options.map((option) => (
          <MenuItem key={option.value || option.label} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default TestFilterSelect;
